// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  AfilePage
} from './';

export default {
  path: 'file',
  name: 'File',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: AfilePage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/file/route.js